var _path, _path2, _path3, _rect, _path4, _path5, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAqaAddSnapshotV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.33,12.11V11H12.11A1.11,1.11,0,0,0,11,12.11v2.22h1.11V12.11Zm5.56,0v2.22H21V12.11A1.11,1.11,0,0,0,19.89,11H17.67v1.11ZM21,19.89V17.67H19.89v2.22H17.67V21h2.22A1.11,1.11,0,0,0,21,19.89Zm-8.89,0V17.67H11v2.22A1.11,1.11,0,0,0,12.11,21h2.22V19.89ZM18.22,16A2.22,2.22,0,1,0,16,18.22,2.21,2.21,0,0,0,18.22,16Zm-3.33,0A1.11,1.11,0,1,1,16,17.11,1.11,1.11,0,0,1,14.89,16Z",
    fill: "#04A6FC",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4,4H28V28H4Z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9,9H23V23H9Z",
    fill: "none"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16,1a4,4,0,0,0-1.91.49L3.89,7.17A3.64,3.64,0,0,0,2,10.32V21.67a3.63,3.63,0,0,0,1.9,3.16L14.08,30.5A3.9,3.9,0,0,0,16,31a4,4,0,0,0,1.92-.49l10.19-5.68A3.64,3.64,0,0,0,30,21.68V12l-1,.57v9.1A2.66,2.66,0,0,1,27.62,24L17.44,29.63A3,3,0,0,1,16,30a3,3,0,0,1-1.43-.37L4.37,24A2.64,2.64,0,0,1,3,21.68V10.34A2.66,2.66,0,0,1,4.38,8L14.56,2.37A3,3,0,0,1,16,2h0a2.92,2.92,0,0,1,1.42.37l3.79,2.11a1.67,1.67,0,0,1,.16-.12l.83-.47L17.92,1.5A3.91,3.91,0,0,0,16,1Z",
    fill: "#04A6FC",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.62,11.64,30,12v9.69a3.64,3.64,0,0,1-1.89,3.15L17.92,30.51A4,4,0,0,1,16,31a3.9,3.9,0,0,1-1.92-.5L3.9,24.83A3.63,3.63,0,0,1,2,21.67V10.32A3.64,3.64,0,0,1,3.89,7.17L14.08,1.49A4,4,0,0,1,16,1a3.91,3.91,0,0,1,1.93.5l4.29,2.39,1-.58L18.41.62A4.93,4.93,0,0,0,16,0h0a4.93,4.93,0,0,0-2.4.62L3.41,6.3a4.62,4.62,0,0,0-2.41,4V21.68a4.62,4.62,0,0,0,2.41,4l10.18,5.68a5,5,0,0,0,4.82,0L28.59,25.7a4.62,4.62,0,0,0,2.41-4V11.34A1.57,1.57,0,0,1,30.62,11.64Z",
    fill: "#04A6FC",
    strokeMiterlimit: 10
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "27 7 27 4 25 4 25 7 22 7 22 9 25 9 25 12 27 12 27 9 30 9 30 7 27 7",
    fill: "#04A6FC",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAqaAddSnapshotV2);
export default __webpack_public_path__ + "static/media/AQA-Add Snapshot - v2.0ad549bc2fb9740671f80d396610bf00.svg";
export { ForwardRef as ReactComponent };